import React from "react";
import { Grid, IconButton } from "@mui/material";
import StringEditor from "../inputs/stringEditor";
import NumberEditor from "../inputs/numberEditor";
import RemoveIcon from "@mui/icons-material/RemoveCircleOutline";
import { FUEL_LINE_ITEM_TYPES } from "../../sharedCode/metadata";
import { GetLineItemPrecision } from "../../sharedCode/HelperMethods";
import { rowMargin, TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { TicketLineItem } from "../../sharedCode/avroGraphql";
import LineItemTypeSelector from "../inputs/selects/lineItemTypeSelector";

interface Props extends TicketProps {
    lineItem: TicketLineItem;
    handleDelete: (lineItemToDelete: TicketLineItem) => void;
    mergeRowChanges: (lineItemId: number, changes: Record<string, unknown>) => void;
}

export default function FuelRow(props: Props): JSX.Element {
    const col1width = 4.0;
    const col2width = 5.0;
    const col3width = 2.0;
    const col4width = 1.0;

    return (
        <Grid container flexDirection={"row"} justifyContent={"center"} alignItems={"center"} columnSpacing={1} sx={{ marginTop: rowMargin }}>
            <Grid container flexDirection={"row"} spacing={1}>
                <Grid xs={col1width} flex={1} item>
                    <LineItemTypeSelector
                        sourceId={props.lineItem.id}
                        sourceProperty="line_item_type_id"
                        labelText="SOURCE"
                        isRequired={true}
                        initialValue={props.lineItem.line_item_type_id}
                        mergeChanges={props.mergeRowChanges}
                        isDisabled={props.isReadOnly}
                        errors={props.errors}
                        containerUrl={"ticket/fuel"}
                        idList={FUEL_LINE_ITEM_TYPES}
                    />
                </Grid>
                <Grid xs={col2width} flex={1} item>
                    <StringEditor
                        sourceId={props.lineItem.id}
                        sourceProperty="comments"
                        labelText="COMMENTS"
                        isRequired={false}
                        initialValue={props.lineItem.comments}
                        mergeChanges={props.mergeRowChanges}
                        isDisabled={props.isReadOnly}
                        errors={props.errors}
                        containerUrl={"ticket/fuel"}
                    />
                </Grid>
                <Grid xs={col3width} flex={1} item>
                    <NumberEditor
                        sourceId={props.lineItem.id}
                        sourceProperty="amount"
                        labelText="LITRES"
                        isRequired={true}
                        initialValue={props.lineItem.amount}
                        mergeChanges={props.mergeRowChanges}
                        isDisabled={props.isReadOnly}
                        errors={props.errors}
                        containerUrl={"ticket/fuel"}
                        precision={GetLineItemPrecision(props.lineItem.line_item_type_id)}
                    />
                </Grid>
                <Grid xs={col4width} item>
                    <IconButton
                        disabled={props.isReadOnly}
                        size="large"
                        edge="start"
                        sx={{ m: 2 }}
                        onClick={() => {
                            props.handleDelete(props.lineItem);
                        }}>
                        <RemoveIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    );
}
